import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { Language } from '../../models';
import { BaseComponent } from '../../core';
import { AbstractI18nService } from '../../services';
import { CommonModule } from '@angular/common';
import { LibCoreLayoutModule } from '../core-layout';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatRadioModule } from '@angular/material/radio';

@Component({
  selector: 'lib-language-selection-dialog',
  templateUrl: './language-selection-dialog.component.html',
  styleUrls: ['./language-selection-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    LibCoreLayoutModule,
    TranslateModule,
    ReactiveFormsModule,
    // Material design
    MatButtonModule,
    MatRadioModule,
  ],
})
export class LanguageSelectionDialogComponent extends BaseComponent {
  public readonly LANGUAGES: Language[];

  public languageControl = new FormControl(null, [Validators.required]);

  constructor(
    private dialogRef: MatDialogRef<LanguageSelectionDialogComponent>,
    private i18nService: AbstractI18nService
  ) {
    super();

    this.LANGUAGES = this.i18nService.getSupportedLanguage();

    this.i18nService.selectedLanguage$
      .pipe(takeUntil(this.componentDestroyed), distinctUntilChanged())
      .subscribe((v) => this.languageControl.setValue(v));
    this.languageControl.valueChanges
      .pipe(takeUntil(this.componentDestroyed), distinctUntilChanged())
      .subscribe((v) => this.i18nService.setLanguage(v));
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }
}
